import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import get from 'lodash/get'
import { authSelector, standardPriceSelector, lobSelector, employeeLevelsSelector, employeeSelector } from './../../../selectors'
import { authAction, standardPriceAction, lobAction, employeeAction } from './../../../actions/'
import CustomTableStandardPrice from '../../../components/table-standard-price'

const header = ['Start Date', 'Pay Grade ID', 'Pay Grade Name', 'Cost', 'Price', 'Modified By']

class ListStandardPrice extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      standardPrice: [],
      level: [],
    }
    this.handleClickEdit = this.handleClickEdit.bind(this)
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.getEmployeeList(access_token)
    this.props.listStandardPrice(access_token)
  }

  handleClickEdit(id) {
    this.props.handleClickEdit(true, id)
    this.props.handleSpan(true)
  }

  render() {
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    
    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectEmployeeLevels.isAuthenticated')
    || get(this.props, 'redirectStandardPrice.isAuthenticated')
    const redirect = get(this.props, 'redirectEmployeeLevels.redirect')
    || get(this.props, 'redirectEmployeeLevels.redirect')
    || get(this.props, 'redirectStandardPrice.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }
    if (IsSystemUser !== undefined &&
      IsHRConfidentialUser !== undefined &&
      !(IsSystemUser || IsHRConfidentialUser)) window.location = '/home'

    if (get(this.state, 'standardPrice.length') !== 0
      && get(this.state, 'level.length') !== 0
      && !get(this.state, 'isOK')
    ) {
      this.findName()
    }
    return (
      /* eslint no-underscore-dangle: 0 */
      <CustomTableStandardPrice
        header={ header }
        data={ this.props.standardPrices }
        handleClickEdit={ this.handleClickEdit }
        span={ get(this.props, 'span') }
        table={ this.props.table }
        employeeList={ this.props.employeeList }
      />
    )
  }
}

ListStandardPrice.propTypes = {
  handleClickEdit: PropTypes.func.isRequired,
  listStandardPrice: PropTypes.func.isRequired,
  handleSpan: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  standardPriceData: standardPriceSelector.getListStandardPrice,
  lobData: lobSelector.getListLOB,
  levelData: employeeLevelsSelector.getListEmployeeLevels,
  redirectAuth: authSelector.redirectAuth,
  redirectStandardPrice: standardPriceSelector.redirectStandardPrice,
  redirectEmployeeLevels: employeeLevelsSelector.redirectEmployeeLevels,
  authData: authSelector.getAuth,
  employeeList: employeeSelector.getListUser,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  listStandardPrice: standardPriceAction.getStandardPrice,
  listLOB: lobAction.getLOB,
  resetListStandardPrice: standardPriceAction.resetListStandardPrice,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuth,
  getEmployeeList: employeeAction.getUser,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ListStandardPrice)



// WEBPACK FOOTER //
// ./src/pages/standard-price/list/index.js